<template>
  <div class="content-container">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>知识库</el-breadcrumb-item>
      <el-breadcrumb-item>知识库详情</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="panel mt-20">
      <el-row :gutter="20">
        <el-col :span="16">
          <h6>
            {{ repository.title }}
            <el-tag
              size="mini"
              class="ml-5"
              v-for="item in repository.tag_names"
              :key="item"
              >{{ item }}</el-tag
            >
          </h6>
          <p style="font-size: 12px; margin-top: 10px; margin-bottom: 5px">
            <span
              >{{ repository.user.name }}
              {{
                $time(repository.created_at).format('YYYY-MM-DD HH:mm')
              }}</span
            >
          </p>
          <p style="font-size: 12px; margin-top: 10px; margin-bottom: 5px">
            设备分类：{{ repository.item_category.whole_name }}
          </p>
          <p style="font-size: 12px; margin-top: 10px; margin-bottom: 5px">
            摘要：{{ repository.summary }}
          </p>
          <div class="ql-editor pl-0" v-html="repository.content"></div>
        </el-col>
        <el-col :span="8" style="display: flex; justify-content: flex-end">
          <el-popconfirm
            v-permission="Auth.repositoryStatus"
            :title="`确认${repository.status == 1 ? '撤回' : '发布'}吗？`"
            @confirm="handleSwitchStatus()"
          >
            <el-button
              slot="reference"
              :type="repository.status == 1 ? 'danger' : 'primary'"
              plain
              size="mini"
              >{{ repository.status == 1 ? '撤回' : '发布' }}</el-button
            >
          </el-popconfirm>
          <el-button
            class="ml-10"
            type="primary"
            plain
            size="mini"
            v-if="repository.status == 2"
            v-permission="Auth.repositoryEdit"
            @click="handleEdit"
            >编辑</el-button
          >
        </el-col>
      </el-row>
    </div>

    <repository-former
      :model="model"
      :show.sync="visible"
      @updated="updatedCallback"
    ></repository-former>
  </div>
</template>

<script>
import { repositoryDetail, updateRepositoryStatus } from '@/service/getData'
import RepositoryFormer from './former'
import { clone } from '@/util'
import { NoticeCategoryMap } from '@/config/global'

export default {
  components: {
    RepositoryFormer,
  },
  data() {
    return {
      NoticeCategoryMap,
      id: this.$route.params.id,
      repository: {
        user: {},
        item_category: {},
      },
      model: {},
      visible: false,
    }
  },
  created() {
    this.getData()
  },
  methods: {
    async getData() {
      let res = await repositoryDetail(this.id)
      if (res.code == 0) {
        this.repository = res.data
      }
    },
    handleEdit() {
      this.model = clone(this.repository)
      this.visible = true
    },
    updatedCallback(data) {
      this.repository = data
    },
    async handleSwitchStatus() {
      let res = await updateRepositoryStatus(this.repository.id)
      if (res.code == 0) {
        this.repository.status = this.repository.status == 1 ? 2 : 1
        this.$message({
          message: `操作成功`,
          type: 'success',
          center: true,
        })
      }
    },
  },
}
</script>